export default __webpack_public_path__ + "static/flag-8b0d49db39e29ba1cd5ab33b01d4a6b2.png";